import useProductDetailsStore from '../../../../../../../../stores/ProductDetails/productDetails.store';
import { packDisallowChange } from '../../../../../../../grids/utils/packs.utils';
import { CopiedGrid } from '../../../../../../../orders/orderState.types';
import { OrderProductGridItem } from '../../../../../../../orders/products/orderProducts.types';
import { CopyOrPasteStatusEnum } from '../../../../../../../orders/products/product/components/copy-paste/copyPaste.types';
import { getCopyOrPasteButtonStatus } from '../../../../../../../orders/products/product/components/copy-paste/copyPaste.utils';
import { OrderProductForGridContainer } from '../../../../../../../orders/products/product/grid/components/orderProductGrid/components/grid/types/orderProductGridContainer.types';
import { useStoreBackedGrid } from '../../../../../../../orders/products/product/grid/store/useStoreBackedGrid';

interface UseCombinationMassActionParams {
  copiedGrid: CopiedGrid;
  grid: OrderProductGridItem[];
  product: OrderProductForGridContainer;
  disableGrid?: boolean;
  orderId?: string;
}

interface UseCombinationMassActionOutput {
  isCopiedGridLine: boolean;
  disablePasteAction: boolean;
  isPasteBlockedByPacks: boolean;
  pasteStatus: CopyOrPasteStatusEnum;
}

const useCombinationMassAction = ({
  grid,
  orderId,
  product,
  copiedGrid,
  disableGrid,
}: UseCombinationMassActionParams): UseCombinationMassActionOutput => {
  const storeBackedGrid = useStoreBackedGrid({ combinationKey: product.combinationKey, grid });
  const pastedCombinationKeys = useProductDetailsStore((state) => state.pastedCombinationKeys);
  const isPasted =
    !!product.combinationKey && pastedCombinationKeys.includes(product.combinationKey);

  const isPasteBlockedByPacks = packDisallowChange(
    product.availability,
    product.productAllowChangePreOrderGrid,
    product.productAllowChangeImmediateGrid,
  );

  if (!orderId) {
    return {
      isPasteBlockedByPacks,
      isCopiedGridLine: false,
      disablePasteAction: true,
      pasteStatus: CopyOrPasteStatusEnum.ON_UNABLE_TO_PASTE,
    };
  }

  const pasteStatus = getCopyOrPasteButtonStatus({
    orderId,
    product,
    copiedGrid,
    grid: storeBackedGrid,
    isPasted,
  });

  const isCopiedGridLine = pasteStatus === CopyOrPasteStatusEnum.ON_COPY_SELECTED;

  return {
    pasteStatus,
    isCopiedGridLine,
    isPasteBlockedByPacks,
    disablePasteAction: isCopiedGridLine || !!disableGrid,
  };
};

export default useCombinationMassAction;
